import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalDataSource } from 'angular2-smart-table';
import { EventService, IInvoiceRequest } from '../../services/database/event/event.service';
import { ToastrService } from '../../services/toastr/toastr.service';

@Component({
  selector: 'ngx-invoicerequests',
  templateUrl: './invoicerequests.component.html',
  styleUrls: ['./invoicerequests.component.scss']
})
export class InvoicerequestsComponent implements OnInit {

  invoicerequests: IInvoiceRequest[];
  source: LocalDataSource = new LocalDataSource();
  searchValue: string;
  users: any[];
  userKey: string;
  eventId: string;

  settings = {
    actions: {
      add: false,
      edit: false,
      delete: true,
      position: 'right'
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark-circle"></i>',
      cancelButtonContent: '<i class="nb-close-circled"></i>',
      confirmSave: true
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    }
  };
  mySettings = {
    actions: {
      add: false,
      edit: false,
      delete: true,
      position: 'right'
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark-circle"></i>',
      cancelButtonContent: '<i class="nb-close-circled"></i>',
      confirmSave: true
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
    columns: {
      key: {
        title: 'ID',
        show: false,
        editable: false
      },
      company: {
        title: 'Company',
        type: 'string',
        editable: false
      },
      street: {
        title: 'Street',
        type: 'string',
        editable: false
      },
      postalCode: {
        title: 'Postal code',
        type: 'string',
        editable: false
      },
      city: {
        title: 'City',
        type: 'string',
        editable: false
      },
      vatNr: {
        title: 'VAT',
        type: 'string',
        editable: false
      }
    },
  };

  constructor(
    private eventService: EventService,
    private toastrService: ToastrService,
    private route: ActivatedRoute
    ) {
  }

  ngOnInit(): void {
    this.eventId = this.route.snapshot.paramMap.get('eventId')
    this.eventService.getInvoiceRequests(this.eventId).subscribe((invoicerequests) => {
      const data = [];
      invoicerequests.forEach(invoicerequest => {
        data.push({
          key: invoicerequest.key,
          company: invoicerequest.company ? invoicerequest.company : '',
          street: invoicerequest.street ? invoicerequest.street : '',
          postalCode: invoicerequest.postalCode ? invoicerequest.postalCode : '',
          city: invoicerequest.city ? invoicerequest.city : '',
          vatNr: invoicerequest.vatNr ? invoicerequest.vatNr : '',
        })
      })
      console.log('data2',data)
      this.settings = Object.assign({}, this.mySettings)
      this.source.load(data);
    })
  }

  eventStandRenderer(value: string) {
    return value;
  }

  onDeleteConfirm(event): void {
    if (window.confirm('Are you sure you want to delete this bartender?')) {
      this.eventService.deleteInvoiceRequest(this.eventId, event.data.key).then((succes) => {
          this.userKey = null;
          this.searchValue = null;
          this.toastrService.show('Success', 'Successfully deleted invoice request', 'success');
          event.confirm.resolve();
        })
        .catch((error) => {
          this.userKey = null;
          this.searchValue = null;
          this.toastrService.show('Error', error, 'danger')
        })
    } else {
      event.confirm.reject();
    }
  }

}
